import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import PropTypes from "prop-types";
import { breakpoint } from "../../../../utils/breakpoint";
import "./block-quote.m.css";
import { SvgHandler } from "../../svg-handler/svg-handler";
import edge from "../../../../assets/icons/edge.svg";
import curve from "../../../../assets/icons/curve.svg";

const BlockQuoteBase = ({ element, template = "", externalLink = false, elementAlignment, index }) => {
  const supportedTemplates = {
    default: "",
    "block-quote-1": "wrapper--block-quote-1",
    "block-quote-2": "wrapper--block-quote-2"
  };
  const templateStyle = supportedTemplates[template] ? `wrapper  ${supportedTemplates[template]} ` : `wrapper `;
  const elementStyle = (elementAlignment, index) => {
    const isAlign = {
      0: {
        left: "left",
        right: "right"
      }
    };
    return get(isAlign, [index, elementAlignment], "center");
  };

  let content = get(element, ["metadata", "content"], "");
  let attribution = get(element, ["metadata", "attribution"], "");

  if (externalLink) {
    content = get(element, ["metadata", "content"]).replace(/<a/g, '<a target="_blank"');
  }

  const supportedQuoteIcon = template => {
    const DefaultQuote = breakpoint("mobile") ? (
      <SvgHandler xlinkHref={curve} clazzName="curve" width="48px" height="48px" viewBox="0 0 64px 64px" />
    ) : (
      <SvgHandler xlinkHref={curve} clazzName="curve" width="64px" height="64px" />
    );

    const BlockQuote1 = breakpoint("mobile") ? (
      <SvgHandler xlinkHref={edge} clazzName="edge" width="48px" height="48px" viewBox="0 0 48px 48px" />
    ) : (
      <SvgHandler xlinkHref={edge} clazzName="edge" width="64px" height="64px" />
    );

    const BlockQuote2 = breakpoint("mobile") ? (
      <SvgHandler xlinkHref={edge} clazzName="edge" width="48px" height="48px" viewBox="0 0 48px 48px" />
    ) : (
      <SvgHandler xlinkHref={edge} clazzName="edge" width="64px" height="64px" />
    );

    switch (template) {
      case "block-quote-1":
        return BlockQuote1;
      case "block-quote-2":
        return BlockQuote2;
      default:
        return DefaultQuote;
    }
  };

  return (
    <div styleName={`${templateStyle} ${elementStyle(elementAlignment, index)}`}>
      <div styleName="quote-wrapper">
        <div styleName="content-wrapper">
          <div styleName="icon-border">
            <div styleName="icon">{supportedQuoteIcon(template)}</div>
            <div styleName="border" />
          </div>
          <div styleName="container" dangerouslySetInnerHTML={{ __html: content }} />
        </div>
        <div styleName="author" dangerouslySetInnerHTML={{ __html: attribution }} />
      </div>
    </div>
  );
};

BlockQuoteBase.propTypes = {
  element: PropTypes.shape({
    text: PropTypes.string
  }).isRequired,
  template: PropTypes.oneOf(["default", "block-quote-1", "block-quote-2"]),
  externalLink: PropTypes.bool,
  elementAlignment: PropTypes.object,
  index: PropTypes.number
};

const mapStateToProps = state => ({
  template: get(state, ["qt", "config", "theme-attributes", "story-elements", "block-quote"], "default")
});

export const BlockQuote = connect(mapStateToProps)(BlockQuoteBase);
